class InfiniteTableService {
    selection;
    #bodyRef;
    queryKey;
    #table;
    constructor(bodyRef, table, tableSettings, flatData, queryKey) {
        this.#bodyRef = bodyRef;
        this.#table = table;
        this.queryKey = queryKey;
        if (tableSettings !== undefined && flatData !== undefined) {
            this.selection = Object.keys(tableSettings.state.rowSelection)
                .map((index) => {
                const indexNumber = Number.parseInt(index, 10);
                return flatData[indexNumber];
            });
        }
    }
    resetRowSelection = () => {
        if (this.#bodyRef !== null && this.#bodyRef !== undefined) {
            const rowElements = this.#bodyRef.children;
            Array.from(rowElements).forEach(row => {
                Array.from(row.getElementsByClassName('tk-checkbox__input')).forEach((checkbox) => {
                    const inputElement = checkbox;
                    if (inputElement.checked) {
                        inputElement.click();
                    }
                });
            });
            /*
            * We reset it here too to ensure boxes that are not rendered are correctly toggeled too.
            */
            if (this.#table !== undefined) {
                this.#table.getSelectedRowModel().rows.forEach(r => { r.toggleSelected(); });
            }
        }
    };
    setRowSelection = (ids) => {
        const current = this.#bodyRef;
        if (current !== null && current !== undefined) {
            const rowElements = current.children;
            Array.from(rowElements).forEach(row => {
                Array.from(row.getElementsByClassName('tk-checkbox__input')).forEach((checkbox) => {
                    const inputElement = checkbox;
                    const name = checkbox.getAttribute('name');
                    if (name !== null) {
                        const checkId = name.substring(6);
                        const shouldBeChecked = ids.includes(checkId);
                        if (inputElement.checked !== shouldBeChecked) {
                            inputElement.click();
                        }
                    }
                });
            });
            /*
            * We reset it here too to ensure boxes that are not rendered are correctly toggled too.
            */
            if (this.#table !== undefined) {
                this.#table.getSelectedRowModel().rows.forEach(r => {
                    const checkbox = current.querySelector("input[name='check_" + r.id + "']");
                    if (checkbox === null) {
                        r.toggleSelected();
                    }
                });
            }
        }
    };
    resetRowExpansion = (items) => {
        if (this.#table !== undefined) {
            this.#table.getRowModel().rows.forEach((row) => {
                const shouldBeExpanded = items.some((item) => item === row.original);
                if (shouldBeExpanded !== row.getIsExpanded()) {
                    row.toggleExpanded(shouldBeExpanded);
                }
            });
        }
    };
}
export default InfiniteTableService;
